const getInnerRoutesCacheKey = (routerId: string, pageId: string): string =>
  `${routerId}-${pageId}`;

export { getInnerRoutesCacheKey };
